import { Typography } from "@mui/material";
import { AppAutocomplete, AppDatePicker, AppRadio, AppSelect, AppTextField } from "../../components";

export const THERMAL_VOTE = [
  {
    label: "Hot",
    icon: "images/TEMP/TEMP1.svg",
    value: "-1",
  },
  {
    label: "Warm",
    icon: "images/TEMP/TEMP2.svg",
    value: "-0.5",
  },
  {
    label: "Neutral",
    icon: "images/TEMP/TEMP3.svg",
    value: "0",
  },
  {
    label: "Cool",
    icon: "images/TEMP/TEMP4.svg",
    value: "0.5",
  },
  {
    label: "Cold",
    icon: "images/TEMP/TEMP5.svg",
    value: "1",
  },
];

export const TEMPERATURE = [
  {
    label: "Warm",
    icon: "images/TEMP/TEMP1.svg",
    value: "1",
  },
  {
    label: "Slightly Warm",
    icon: "images/TEMP/TEMP2.svg",
    value: "2",
  },
  {
    label: "Neutral",
    icon: "images/TEMP/TEMP3.svg",
    value: "3",
  },
  {
    label: "Slightly Cool",
    icon: "images/TEMP/TEMP4.svg",
    value: "4",
  },
  {
    label: "Cool",
    icon: "images/TEMP/TEMP5.svg",
    value: "5",
  },
];


export const AIRFLOW = [
  {
    label: "Still",
    icon: "images/AIR/AIR1.svg",
    value: "1",
  },
  {
    label: "Slightly Still",
    icon: "images/AIR/AIR2.svg",
    value: "2",
  },
  {
    label: "Neutral",
    icon: "images/AIR/AIR3.svg",
    value: "3",
  },
  {
    label: "Slightly Breezy",
    icon: "images/AIR/AIR4.svg",
    value: "4",
  },
  {
    label: "Breezy",
    icon: "images/AIR/AIR5.svg",
    value: "5",
  },
];

export const LIGHTING = [
  // {
  //   label: "Bright",
  //   icon: "bright.svg",
  //   iconActive: "bright_active.svg",
  //   value: "bright",
  // },
  // {
  //   label: "Moderate",
  //   icon: "moderate_illuminance.svg",
  //   iconActive: "moderate_illuminance_active.svg",
  //   value: "moderate",
  // },
  // {
  //   label: "Dim",
  //   icon: "dim.svg",
  //   iconActive: "dim_active.svg",
  //   value: "dim",
  // },
  {
    label: "Very Dim",
    icon: "images/LIGHT/LIGHT1.svg",
    value: "1",
  },
  {
    label: "Rather Dim",
    icon: "images/LIGHT/LIGHT2.svg",
    value: "2",
  },
  {
    label: "Moderate",
    icon: "images/LIGHT/LIGHT3.svg",
    value: "3",
  },
  {
    label: "Rather Bright",
    icon: "images/LIGHT/LIGHT4.svg",
    value: "4",
  },
  {
    label: "Very Bright",
    icon: "images/LIGHT/LIGHT5.svg",
    value: "5",
  },
];

export const FieldBirthDate = [
  {
    id: "birthDate",
    views: ['year', 'month', 'day'],
    label: "DD/MM/YYYY",
    xs: 12,
    format: 'dd/MM/yyyy',
    props: {
      editable: false,
    },
    component: AppDatePicker,
  },
  // {
  //   id: "day",
  //   label: 'Day',
  //   xs: 4,
  //   required: true,
  //   component: AppTextField,
  //   props: {
  //     variant: "outlined"
  //   }
    
  // },
  // {
  //   id: "month",
  //   label: 'Month',
  //   xs: 4,
  //   required: true,
  //   component: AppTextField,
  //   props: {
  //     variant: "outlined"
  //   }
  // },
  // {
  //   id: "year",
  //   label: 'Year',
  //   xs: 4,
  //   required: true,
  //   component: AppTextField,
  //   props: {
  //     variant: "outlined"
  //   }
  // },
];

export const FieldGender = [
  {
    id: "gender",
    label: "Gender",
    xs: 12,
    component: AppRadio,
    defaultValue: "unknown",
    props: {
      title: "",
      label: [
        { id: "male", label: "Male" },
        { id: "female", label: "Female" },
        { id: "unknown", label: "Unspecified" },
      ],
    },
  },
];

export const RaceOptions = [
	{
		id: '-1',
		label: 'Please specify your race',
	},
	{
		id: 'Chinese',
		label: 'Chinese',
	},
	{
		id: 'Malay',
		label: 'Malay',
	},
	{
		id: 'Indian',
		label: 'Indian',
	},
	{
		id: 'Other',
		label: 'Others',
	},
];

export const OTHER_STR = 'Other';

export const FieldRace = [
  {
    id: "race",
    xs: 12,
    component: AppAutocomplete,
    defaultValue: "-1"
  }
];

export const FieldRace_Other = [
  {
    id: "other",
    label: 'Enter your race',
    xs: 12,
    required: true,
    component: AppTextField,
    props: {
      variant: "outlined"
    }
  },
];

export const HeadTable = [
  {
    id: "company",
    label: "",
    align: "left",
    width: 150
  },
  {
    id: "departmentName",
    label: "",
    align: "left",
    width: 150
  },
  {
    id: "displayName",
    label: "",
    align: "left",
    width: 150,
    format: (val, row) => {
      return (
        <div>
          <Typography>{val}</Typography>
          <small style={{ color: 'blue'}}>{row?.updated_by || '' }</small>
        </div>
      )
    }
  },
  {
    id: "location",
    label: "",
    align: "left",
  }
];
